import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-auto w-10 h-10 rounded bg-gradient-to-br from-gray-200 to-gray-300 text-black flex"
}
const _hoisted_2 = {
  key: 1,
  class: "m-auto w-10 h-10 rounded bg-gradient-to-br from-red-200 to-red-300 text-red-700 flex"
}
const _hoisted_3 = {
  key: 2,
  class: "m-auto w-10 h-10 rounded bg-gradient-to-br from-gray-200 to-gray-300 text-gray-500 flex"
}

import { computed, toRefs } from 'vue';
import { AccountPresenter } from '@/models';

interface Props {
  state?: 'search' | 'error' | 'loading',
  presenter?: AccountPresenter | null,
  icon?: string,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    state: null,
    presenter: null,
    icon: { default: 'icon-warning' }
  },
  setup(__props: any) {

const props = __props as { state?: 'search' | 'error' | 'loading', presenter?: AccountPresenter | null, icon: string }



const { state, presenter, icon } = toRefs(props);
const effectiveIcon = computed(() => presenter?.value?.icon ?? icon.value);
const effectiveIconClass = computed(() => presenter?.value?.iconClass ?? null);
const effectiveIconUrl = computed(() => presenter?.value?.iconUrl ?? null);

return (_ctx: any,_cache: any) => {
  const _component_icon_search = _resolveComponent("icon-search")!
  const _component_icon_x = _resolveComponent("icon-x")!
  const _component_icon_loading = _resolveComponent("icon-loading")!

  return (_unref(state) === 'search')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_icon_search, { class: "h-5 w-5 m-auto" })
      ]))
    : (_unref(state) === 'error')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_icon_x, { class: "h-5 w-5 m-auto" })
        ]))
      : (_unref(state) === 'loading')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_icon_loading, { class: "h-5 w-5 m-auto animate-spin" })
          ]))
        : (_unref(effectiveIconUrl))
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "m-auto w-10 h-10 rounded flex bg-center bg-no-repeat bg-[length:100%_100%]",
              style: _normalizeStyle(`background-image: url('${_unref(effectiveIconUrl)}')`)
            }, null, 4))
          : (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: _normalizeClass(["m-auto w-10 h-10 rounded flex", _unref(effectiveIconClass)])
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(effectiveIcon)), { class: "h-5 w-5 m-auto" }))
            ], 2))
}
}

})